// cleanup old dashboards settings
export default (settings: Record<string, any>) => {
  if (settings.dashboards !== undefined) {
    settings.dashboards = undefined
  }
  if (settings['dashboards-app'] !== undefined) {
    settings['dashboards-app'] = undefined
  }
}
